module.exports = __webpack_public_path__ + "static/img/logo5@2x.5b4d9ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/logo5@2x.png
// module id = myxi
// module chunks = 70